<!-- THIS IS A TEMPLATE TO COPY AND PASTE -->
<div style="width: 500px; height: 300px;" data-cy="patient-halt-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="patient-halt-header-section">
      <div class="section-header-title" data-cy="patient-halt-title-text">
        WAIT!
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; color: red;" data-cy="patient-halt-content-section">
      <div *ngIf="data.isSentCollection" data-cy="patient-halt-collection-message">
        This patient has been marked as In Collection
      </div>
      <div *ngIf="data.isDoNotEverTreatAgain" data-cy="patient-halt-dneta-message">
        This patient has been marked as Do Not Ever Treat Again
      </div>
      <div *ngIf="data.isDeceased" data-cy="patient-halt-deceased-message">
        This patient has been marked as Deceased
      </div>
      <div *ngIf="data.isDoNotSchedule" data-cy="patient-halt-dns-message">
        This patient has been marked as Do Not Schedule
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 46px;" data-cy="patient-halt-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="patient-halt-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="patient-halt-ok-button">Ok</button>
    </div>
  </div>
</div>
